import { useSearchParams } from 'react-router';

const LIST_DELIMITER = ',';

export const useLocalSearchParamState = (name: string, defaultValue = ''): [string, (value: string) => void] => {
    const [searchParams, setSearchParams] = useSearchParams();
    const state: string = searchParams.get(name) ?? defaultValue;

    const setState = (value: string) => {
        const updatedSearchParams = new URLSearchParams(window.location.search);
        if (value === defaultValue) {
            updatedSearchParams.delete(name);
        } else {
            updatedSearchParams.set(name, value);
        }
        setSearchParams(updatedSearchParams, { replace: true });
    };

    return [state, setState];
};

export function useLocalListSearchParamState(
    name: string,
    defaultValues: string[] = [],
): [string[], (values: string[]) => void] {
    const [value, setValue] = useLocalSearchParamState(name, defaultValues.join(LIST_DELIMITER));
    const values = value === '' ? [] : value.split(LIST_DELIMITER);
    const setValues = (values: string[]) => setValue(values.join(LIST_DELIMITER));

    return [values, setValues];
}
